import { render, staticRenderFns } from "./wagesTemplate.vue?vue&type=template&id=c5596e92&scoped=true&"
import script from "./wagesTemplate.vue?vue&type=script&lang=js&"
export * from "./wagesTemplate.vue?vue&type=script&lang=js&"
import style0 from "./wagesTemplate.vue?vue&type=style&index=0&id=c5596e92&scoped=true&lang=css&"
import style1 from "./wagesTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5596e92",
  null
  
)

export default component.exports